<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>报名名单</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{activityName}}</div>
      </div>
      <div class="header-tool-box">
      <Input
          search
          placeholder="请输入公司名称或活动名称"
          v-model="companyNameOrActivityName"
          @on-search="init()"
          style="width:230px;margin-top:20px;"
        />
        <div class="htb-item" @click="exportHandle">
          <span>导出</span>
        </div>
        <div class="htb-item" @click="$router.go(-1)">
          <span>返回</span>
        </div>
      </div>
    </div>
    <div class="layout-content" style="background: transparent">
      <Table :border="false" row-key="id" :columns="columns" :data="list">
        <template slot-scope="{ row, index }" slot="applyCompanyName">{{ row.applyCompanyName }}</template>
        <template slot-scope="{ row, index }" slot="linkName">{{
          row.linkName
        }}</template>
        <template slot-scope="{ row, index }" slot="linkTel">{{ row.linkTel }}</template>
        <template slot-scope="{ row, index }" slot="linkEmail">{{
          row.linkEmail
        }}</template>
        <template slot-scope="{ row, index }" slot="linkDepartment">{{ row.linkDepartment }}</template>
        <template slot-scope="{ row, index }" slot="linkJobTitle">{{ row.linkJobTitle }}</template>
        <template slot-scope="{ row, index }" slot="inDate">{{row.inDate | moment("YYYY/MM/DD HH:mm:ss")}}</template>
      </Table>
      <div
        class="my-page"
        v-if="totalCount > pageSize"
        style="margin: 20px; text-align: center"
      >
        <Page
          show-total
          show-elevator
          :page-size="pageSize"
          :current="pageIndex"
          :total="totalCount"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
let moment = require("moment");
import { mapGetters, mapActions } from "vuex";
import wangeditor from "wangeditor";
import config from "@assets/config.json";

import axios from "axios";

export default {
  name: "common-banner-add",
  data() {
    return {
      uploadUrl: `${config.api.reqApi}/api/upload/files`,
      type: "firstPage",
      show: true,
      titleModel: "新增活动",
      loading: false,
      showModal: false,
      formInline: {
        id:'',
        name: "",
        showIndex: 0,
        skipType: "",
        content: "",
        url: "",
      },
      ruleInline: {
        name: [{ required: true, message: "请输入", trigger: "change" }],
        skipType: [{ required: true, message: "请选择", trigger: "change" }],
        showIndex: [{ required: true, message: "请输入", trigger: "change" }],
        content: [{ required: true, message: "请输入", trigger: "change" }],
        url: [{ required: true, message: "请输入", trigger: "change" }],
      },
      uploadList: [],
      defaultList: [],
      imgName: "",
      visible: false,
      typeList: [
        { value: "url", label: "外链" },
        { value: "textArea", label: "图文" },
      ],
      columns: [
        {
          title: "公司名称",
          key: "applyCompanyName",
          slot: "applyCompanyName",
        },
        {
          title: "联系人姓名",
          key: "linkName",
          slot: "linkName",
        },
        {
          title: "电话",
          key: "linkTel",
          slot: "linkTel",
        },
        {
          title: "邮箱",
          key: "linkEmail",
          slot: "linkEmail",
        },
        {
          title: "部门",
          key: "linkDepartment",
          slot: "linkDepartment",
        },
        {
          title: "职务",
          key: "linkJobTitle",
          slot: "linkJobTitle",
        },
        {
          title: "报名时间",
          key: "inDate",
          slot: "inDate",
        },

       
      ],
      list: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      fileId: "",
      companyNameOrActivityName: "",
    };
  },
  //   watch: {
  //     show (val, oldVal) {
  //       this.showModal = val;
  //       if (!val) this.$emit("close");
  //     }
  //   },
  computed: {
    ...mapGetters({
      uploadUrl2: "getUploadUrl2",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
    idActivity() {
     return this.$route.query.id
    },
    activityName() {
     return this.$route.query.activityName
    },
    option() {
      return {
        exhibitionId: this.exhibitionInfo.id,
        activityId:this.idActivity,
        companyNameOrActivityName:this.companyNameOrActivityName,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "",
                  Value: "",
                },
              },
            ],
          },
        },
      };
    },
  },
  mounted() {
    // this.initEditor();
    this.init(this.idActivity);
  },
  methods: {
    ...mapActions({
      PCActivityAdd: "hostSetModule/PCActivityAdd",
   
      PCActivityRegLogPage: "hostSetModule/PCActivityRegLogPage",
      PCActivityRegLogExcelExportLog: "hostSetModule/PCActivityRegLogExcelExportLog",
    }),
 
    async init() {
      let list = await this.PCActivityRegLogPage(this.option);
      console.log(list,'listlistlistlistlist');
      if (list && list.items.length > 0) {
        this.list = list.items;
      } else {
        this.list = [];
      }
      this.pageIndex = list.pageIndex;
      this.pageSize = list.pageSize;
      this.totalCount = list.totalCount;
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    async review(e) {
      let bool = await this.putApplyState({
        exchangeOrderId: e.exchangeOrderId,
        exchangeCompanyId: e.exchangeCompanyId,
      });
      if (bool && bool.successed) {
        this.$Message.success({
          content: "操作成功，数据同步需要时间，请稍后重新刷新页面获取最新状态！",
          duration: 5,
        });
      } else {
        this.$Message.success("操作失败，请重试！");
      }
      this.init();
    },
    async exportHandle() {
      let res = await this.PCActivityRegLogExcelExportLog(this.option);
      if (res) {
        const aLink = document.createElement("a");
        let blob = new Blob([res], {
          type: "application/vnd.ms-excel",
        });
        aLink.href = URL.createObjectURL(blob);
        aLink.setAttribute("download", this.activityName+"报名名单" + ".xlsx"); // 设置下载文件名称
        document.body.appendChild(aLink);
        aLink.click();
      }
    },
    async editHandel(e) {
      this.titleModel = "编辑活动";
      this.formInline.id = e.id;
      this.formInline.name = e.name;
      this.formInline.skipType = e.type;
      this.formInline.content = e.content;
      this.formInline.url = e.url;
      this.formInline.showIndex = e.showIndex;

      this.editor.txt.html(e.content);

      this.showModal = true;

      console.log(e);
    },
  },
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}

.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }

  &-content {
    .submit {
      display: flex;
      justify-content: center;

      button {
        margin-left: -75px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .form-code-item {
    position: relative;

    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;

      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>
<style lang="scss">
.common-ad-add {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

.disabled {
  &.ivu-btn.ivu-btn-default:hover,
  &.ivu-btn.ivu-btn-default:focus,
  &.ivu-btn.ivu-btn-default:active,
  &.ivu-btn.ivu-btn-default:visited {
    color: inherit;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  // IE10+ CSS styles go here
  .common-ad-add {
    display: block;

    .ivu-modal {
      top: 150px;
    }
  }
}
</style>
